export default function getExtendedPropertyValue(item, tag) {
    if (!item || !item.ExtendedProperty) {
        return null;
    }
    for (var i = 0; i < item.ExtendedProperty.length; i++) {
        var extendedProperty = item.ExtendedProperty[i];
        var propertyTag = extendedProperty && extendedProperty.ExtendedFieldURI
            ? extendedProperty.ExtendedFieldURI.PropertyTag
            : null;
        if (propertyTag == tag) {
            return extendedProperty.Value;
        }
    }
    return null;
}
//# sourceMappingURL=getExtendedPropertyValue.js.map